import React, { useEffect, useState } from 'react';
import ReactCardFlip from 'react-card-flip';
import { CorporateActionsCapsuleContentFront } from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleContentFront';
import { CorporateActionsCapsuleContentBack } from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleContentBack';
import { useCapsuleBoundSymbol } from 'widgets/tiles/components/tile/hooks';
import { Row } from 'widgets/corpActions/capsule/components/corporateActionsCapsuleData';
import { CorporateActionsCapsuleConfigState } from 'widgets/corpActions/capsule/store/CorporateActionsCapsuleConfigState';
import { EnrichedSymbolEvent } from 'widgets/corpActions/store/data/earningsAftMktOnTMinus1.ts';

export interface CorporateActionsCapsuleContentProps {
    data: EnrichedSymbolEvent[];
    config: CorporateActionsCapsuleConfigState;
    symbol?: string;
}

export function CorporateActionsCapsuleContent(
    props: CorporateActionsCapsuleContentProps
) {
    const { data, symbol: symbolProps, config } = props;
    const [selectedRow, setSelectedRow] = useState<Row | undefined>();

    const isFlipped = !!selectedRow;
    const { symbol: boundSymbol } = useCapsuleBoundSymbol();

    const symbol = symbolProps ?? boundSymbol;

    useEffect(() => {
        setSelectedRow(undefined);
    }, [symbol]);

    if (!symbol || data.length === 0) {
        return <div className="CorporateActionsCapsuleContent">No data</div>;
    }

    if (data.length === 0) {
        return <div className="CorporateActionsCapsuleContent">No Events</div>;
    }

    const onRowClick = (nextSelectedRow?: Row) => {
        setSelectedRow(nextSelectedRow);
    };

    const selectedItem =
        selectedRow && data.find((c) => c.uuid === selectedRow.uuid);

    const backClassName = selectedRow
        ? selectedRow.isTminus1AftMftEarnings
            ? 'aftmkt-earnings-ontminus1'
            : selectedRow.type === 'Upcoming'
            ? 'upcoming'
            : selectedRow.type === 'Historical'
            ? 'historical'
            : selectedRow.type === 'Today'
            ? 'today'
            : ''
        : '';

    return (
        <div className="CorporateActionsCapsuleContent flippable">
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <CorporateActionsCapsuleContentFront
                    key="front"
                    config={config}
                    data={data}
                    onRowClick={onRowClick}
                />
                <CorporateActionsCapsuleContentBack
                    key="back"
                    className={backClassName}
                    data={selectedItem}
                    onClick={() => setSelectedRow(undefined)}
                />
            </ReactCardFlip>
        </div>
    );
}
